import api from '@/services/api-service';
import RestResource from '@/services/resources/restResource';

export class ExpiredItemsResource extends RestResource {
    /**
     *
     * @param {ApiClient} apiClient
     * @param {string} endpoint
     */
    constructor(apiClient, endpoint = 'items/expiredLotItems') {
        super(apiClient, endpoint);
    }

    getAll() {
        return this.find();
    }

    expireItemsToCreateOrder() {
        const url = `${this.api.baseURL}/items/expireItemsToCreateOrder`;
        return this.api.get(url);
    }

    getExpiredInventories() {
        return `${this.api.baseURL}/items/expiredLotItems`;
    }

    getFilters() {
        return this.api.get(`${this.api.baseURL}/items/expiredLotItemsFilters`);
    }
}

export default new ExpiredItemsResource(api);
